import React from "react";
import { connect } from "react-redux";
import {
  toggleSidebar,
  logout,
  logoutforCustom,
} from "../redux/actions/sidebarActions";
import { Link } from "react-router-dom";
import { toastr } from "react-redux-toastr";
import "./logo.scss";
import * as myConstClass from "../constant.js";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import {
  Row,
  Col,
  Collapse,
  Navbar,
  Nav,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  ListGroup,
  ListGroupItem,
  Form,
  Button,
} from "reactstrap";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBell,
  faEnvelopeOpen,
  faCog,
  faArrowAltCircleRight,
  faExclamationTriangle,
  faShoppingCart,
  faHandsHelping,
  faBook,
  faWeight,
  faTable,
} from "@fortawesome/free-solid-svg-icons";
import { T, TF, LanguageList, Config } from "react-translator-component";

Config.list = {
  en: {
    text: "English",
    file: require("../locale/en.js"),
  },
  // KH: {
  //   text: "Khmer",
  //   file: require("../locale/KH.js"),
  // },
   Mal: {
    text: "Malesian",
    file: require("../locale/Mal.js"),
  },
  ch: {
    text: "Chinese",
    file: require("../locale/ch.js"),
  },
};
//localStorage.removeItem("lang");
Config.default = localStorage.getItem("lang");

const NavbarDropdown = ({
  children,
  count,
  header,
  footer,
  icon,
  active,
  indicator,
}) => (
  <UncontrolledDropdown nav inNavbar className="ml-lg-1" active={active}>
    <DropdownToggle nav className="nav-icon dropdown-toggle position-relative">
      <FontAwesomeIcon icon={icon} className="align-middle" />
      {indicator ? <span className="indicator" /> : ""}
    </DropdownToggle>
    <DropdownMenu right className="dropdown-menu-lg py-0">
      <div className="dropdown-menu-header position-relative">
        {count} {header}
      </div>
      <ListGroup>{children}</ListGroup>
      <DropdownItem header className="dropdown-menu-footer">
        <span className="text-muted">{footer}</span>
      </DropdownItem>
    </DropdownMenu>
  </UncontrolledDropdown>
);

const NavbarToggle = connect((store) => ({
  app: store.app,
}))(({ dispatch }) => {
  return (
    <span
      className="sidebar-toggle d-flex mr-2"
      onClick={() => {
        dispatch(toggleSidebar());
      }}
    >
      <i className="hamburger align-self-center" />
    </span>
  );
});

const NavbarSearch = connect((store) => ({
  sidebar: store.sidebar,
}))(() => {
  return (
    <Form inline>
    </Form>
  );
});

class Navbarnew extends React.Component {
  constructor(props) {
    super(props);
    this.edit = this.edit.bind(this);
    this.googleTranslateElementInit =
      this.googleTranslateElementInit.bind(this);
    this.state = {};
    this.state = {
      issueLength: 0,
      empData: [],
      msgcount: "",
      ordercount: "",
      complaintcount: "",
      leavecount: "",
      documentcount: "",
      pro_package: "",
      unseencount: "",
    };
  }


  componentDidMount() {
    window.googleTranslateElementInit = this.googleTranslateElementInit;
    const script = document.createElement("script");
    script.src =
      "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
    script.async = true;
    document.body.appendChild(script);

    const admin_id = localStorage.getItem("uname");
    const login_id = localStorage.getItem("login_id");
    const login_type = localStorage.getItem("login_type");

    const endpoints = [
      {
        url: "attendance/getEmployeeIssues/0/1",
        callback: (data) => this.setState({ issueLength: data.length }),
      },
      {
        url: `user/getunreadunseenCount/${admin_id}/${login_id}/${login_type}`,
        callback: (data) => this.setState({ unseencount: data }),
      },
      {
        url: `user/getunreadMessagesCountOld/${admin_id}/${login_id}/${login_type}`,
        callback: (data) => this.setState({ msgcount: data }),
      },
      {
        url: `user/getunreadOrderCount/${admin_id}/${login_type}`,
        callback: (data) => this.setState({ ordercount: data }),
      },
      {
        url: `user/getunreadComplaintCount/${admin_id}/${login_id}/${login_type}`,
        callback: (data) => this.setState({ complaintcount: data }),
      },
      {
        url: `user/getunreadLeaveCount/${admin_id}/${login_id}/${login_type}`,
        callback: (data) => this.setState({ leavecount: data }),
      },
      {
        url: `user/getunreadDocumentCount/${admin_id}/${login_id}/${login_type}`,
        callback: (data) => this.setState({ documentcount: data }),
      },
      {
        url: `user/getunreadunseenCountOt/${admin_id}/${login_id}/${login_type}`,
        callback: (data) => this.setState({ otcount: data }),
      },
    ];

    this.performFetchRequests(endpoints);

    // this.interval = setInterval(() => this.tick(), 10000); // Optional
  }

  tick() {
    const admin_id = localStorage.getItem("uname");
    const login_id = localStorage.getItem("login_id");
    const login_type = localStorage.getItem("login_type");

    const endpoints = [
      {
        url: `user/getunreadunseenCount/${admin_id}/${login_id}/${login_type}`,
        callback: (data) => this.setState({ unseencount: data }),
      },
      {
        url: "attendance/getEmployeeIssues/0/1",
        callback: (data) => this.setState({ issueLength: data.length }),
      },
      {
        url: `user/getunreadComplaintCount/${admin_id}/${login_id}/${login_type}`,
        callback: (data) => this.setState({ complaintcount: data }),
      },
      {
        url: `user/getunreadLeaveCount/${admin_id}/${login_id}/${login_type}`,
        callback: (data) => this.setState({ leavecount: data }),
      },
      {
        url: `user/getunreadOrderCount/${admin_id}/${login_type}`,
        callback: (data) => this.setState({ ordercount: data }),
      },
    ];

    this.performFetchRequests(endpoints);
  }

  performFetchRequests = (requests) => {
    requests.forEach(({ url, callback }) => {
      fetch(`${myConstClass.BASE_URL}${url}`)
        .then((res) => res.json())
        .then(callback)
        .catch((err) => console.error(`Error fetching ${url}:`, err));
    });
  };

  googleTranslateElementInit() {
    const google = window.google;
    if (!google?.translate) return;

    new google.translate.TranslateElement(
      { pageLanguage: "en" },
      "google_translate_elementnav"
    );
    new google.translate.TranslateElement(
      {
        pageLanguage: "pt",
        layout: google.translate.TranslateElement.InlineLayout.SIMPLE,
      },
      "google_translate_elementnav"
    );
  }


   change_dashboard(type) {
     // alert(type);
      
      if (type == "1") {
        localStorage.setItem("on_subadmin_dashboard", "1");
      localStorage.setItem("login_type", "sub_admin");
      localStorage.setItem("is_subadmin", "0");
        localStorage.setItem("is_sub_admin_with_payroll", "1");
        window.location.href = "/" + myConstClass.TENANT_PAGE_PATH + "dashboard";
      } else if (type == "2") {
        localStorage.setItem("on_subadmin_dashboard", "1");
         localStorage.setItem("login_type", "sub_admin");
         localStorage.setItem("is_subadmin", "0");
        localStorage.setItem("is_sub_admin_with_payroll", "2");
        window.location.href = "/" + myConstClass.TENANT_PAGE_PATH + "dashboard";
      }
      else{
        localStorage.setItem("on_subadmin_dashboard", "2");
        
        var is_payroll_privilage = localStorage.getItem("is_payroll_privilage");
        //alert(is_payroll_privilage);
        if(is_payroll_privilage!='0')
        {
          localStorage.setItem("login_type", "emp");
          localStorage.setItem("is_payroll_privilage", "1");
        }
        else{
          localStorage.setItem("is_subadmin", "1");
          localStorage.setItem("login_type", "emp");
          localStorage.setItem("is_payroll_privilage", "0");
        }
        
  
        //localStorage.setItem("is_sub_admin_with_payroll", "0");
        window.location.href = "/" + myConstClass.TENANT_PAGE_PATH + "employees/profileinfo";
      }
  
     
     
    }

  change_common_url() {
    localStorage.clear();
    window.location.href = "https://wzonekh.com/dashboard.php";
  }

  change_custom() {
    localStorage.setItem("login_type", "hr_admin");
    localStorage.setItem("custom", "1");
    window.location.href = `/${myConstClass.TENANT_PAGE_PATH}reportscustom/listing`;
  }

  edit(e) {
    const add_msg = localStorage.getItem("view_msg");
    const login_type = localStorage.getItem("login_type");

    const checkPermission = (permKey) =>
      (localStorage.getItem(permKey) === "0" && login_type !== "hr_admin") ||
      (!localStorage.getItem(permKey) && login_type !== "hr_admin") ||
      login_type === "emp" ||
      login_type === "security";

    const routes = {
      complaint: "employeescomplaints/listing",
      issue: "employeesissues/listing",
      document: "employeesadmin_staff/listingdocs",
      msg: "empmsg/listing",
      order: "shopsorder/listing",
      leave: "shiftsleaves/listing",
      ot: "shiftsotrequest/listing",
    };

    const fetchMap = {
      complaint: "user/getunreadunseenCountcomplaint",
      document: "user/getunreadDocumentCount",
      msg: "user/getunreadunseenCountmsg",
      leave: "user/getunreadunseenCountleave",
      ot: "user/getunreadunseenCountOt",
    };

    const permKeyMap = {
      complaint: "comnot",
      issue: "issue",
      document: "docnot",
      msg: "msgnot",
      order: "ordernot",
      leave: "leavenot",
      ot: "otnot",
    };

    if (checkPermission(permKeyMap[e])) {
      toastr.error(TF("{0}", T("Error")), add_msg);
      return;
    }

    if (fetchMap[e]) {
      fetch(`${myConstClass.BASE_URL}${fetchMap[e]}`)
        .then((res) => res.json())
        .catch((err) => console.error(err));
    }

    window.location.href = `/${myConstClass.TENANT_PAGE_PATH}${routes[e]}`;
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  show_qrcode() {
    localStorage.setItem("custom", "1");
    window.location.href = "/SignInCustom";
  }

  render() {
    const { sidebar } = this.props;
    const admin_id = localStorage.getItem("uname");
    const login_id = localStorage.getItem("login_id");
    const login_type = localStorage.getItem("login_type");
    const is_google_translator =
      localStorage.getItem("is_google_transaltor") === "1";
    const is_subadmin = localStorage.getItem("is_subadmin") === "1";
    const is_payroll_privilege =
      localStorage.getItem("is_payroll_privilage") !== "0";
    const on_subadmin_dashboard = localStorage.getItem("on_subadmin_dashboard");
    const common_login = localStorage.getItem("common_login") === "1";
    const lang = localStorage.getItem("lang");

    const {
      unseencount = [],
      documentcount,
      complaintcount,
      msgcount,
      leavecount,
      issueLength,
      ordercount,
      otcount,
    } = this.state;

    const balance_div_urlnew = (() => {
      if (
        is_subadmin &&
        !is_payroll_privilege &&
        login_type === "emp" &&
        on_subadmin_dashboard === "2"
      ) {
        return (
          <Button
            className="button_change_dashboard"
            onClick={() => this.change_dashboard(1)}
          >
            Change To Sub Admin Dashboard
          </Button>
        );
      }
      if (
        is_payroll_privilege &&
        login_type === "emp" &&
        on_subadmin_dashboard === "2"
      ) {
        return (
          <Button
            className="button_change_dashboard"
            onClick={() => this.change_dashboard(2)}
          >
            Change To Payroll Admin Dashboard
          </Button>
        );
      }
      if (login_type === "sub_admin" && on_subadmin_dashboard === "1") {
        return (
          <Button
            className="button_change_dashboard"
            onClick={() => this.change_dashboard(3)}
          >
            Change To Emp Dashboard
          </Button>
        );
      }
      return null;
    })();

    const custom_url =
      localStorage.getItem("is_custom") === "1" &&
      !localStorage.getItem("custom") ? (
        <Button
          className="button_change_dashboard"
          onClick={this.change_custom}
        >
          Custom
        </Button>
      ) : null;

    const back_common_url = common_login ? (
      <Button
        className="button_change_dashboard"
        onClick={this.change_common_url}
      >
        Back
      </Button>
    ) : null;

   
const renderIconBadge = (Icon, count, action, titleFalse, titleTrue, tooltipText) => {
  const tooltip = (
    <Tooltip id={`tooltip-${action}`}>
      {tooltipText || titleTrue || titleFalse}
    </Tooltip>
  );

  return (
    <UncontrolledDropdown nav inNavbar className="ml-lg-1" key={action}>
      <DropdownToggle
        nav
        className="nav-icon dropdown-toggle position-relative"
      >
        <OverlayTrigger placement="bottom" overlay={tooltip}>
          <div onClick={() => this.edit(action)} style={{ cursor: "pointer" }}>
            <FontAwesomeIcon icon={Icon} className="align-middle" />
            {count ? (
              <span className="float-right badge badge-error">{count}</span>
            ) : null}
          </div>
        </OverlayTrigger>
      </DropdownToggle>
    </UncontrolledDropdown>
  );
};

    return (
      <Navbar expand className="navbar-theme">
        {!sidebar.isOnRight ? (
          <>
            <NavbarToggle />
            <NavbarSearch />
            <Collapse navbar>
              <Nav
                className={!sidebar.isOnRight ? "ml-auto" : "mr-auto"}
                navbar
              >
                {balance_div_urlnew}
                {back_common_url}
                {is_google_translator ? (
                  <div id="google_translate_elementnav"></div>
                ) : (
                  <div>
                    <LanguageList Language={lang} style={{ display: "none" }} />
                    <label style={{ color: "white" }}>Select Language</label>
                    <select
                      className="custom-language-list"
                      value={lang}
                      onChange={(e) => {
                        localStorage.setItem("lang", e.target.value);
                        window.location.reload();
                      }}
                    >
                      {Object.entries(Config.list).map(([key, val]) => (
                        <option key={key} value={key}>
                          {val.text}
                        </option>
                      ))}
                    </select>
                  </div>
                )}

              {(login_type === "hr_admin") && (
  <>
    {renderIconBadge(faBook, documentcount, "document", "Documents", "Documents", `You have ${documentcount} documents.`)}
    {renderIconBadge(faWeight, otcount, "ot", "OT", "OT Requests", `You have ${otcount} OT requests.`)}
    {renderIconBadge(faExclamationTriangle, complaintcount, "complaint", "Complaint", "Complaints", `You have ${complaintcount} complaints.`)}
    {renderIconBadge(faEnvelopeOpen, msgcount, "msg", "Messages", "Messages", `You have ${msgcount} messages.`)}
    {renderIconBadge(faTable, leavecount, "leave", "Leave", "Leave Requests", `You have ${leavecount} leave requests.`)}
    {renderIconBadge(faHandsHelping, issueLength, "issue", "Issues", "Issues", `You have ${issueLength} issues to handle.`)}
    {renderIconBadge(faShoppingCart, ordercount, "order", "Orders", "Orders", `You have ${ordercount} orders.`)}
  </>
)}

                <UncontrolledDropdown nav inNavbar className="ml-lg-1">
                  <DropdownToggle nav caret>
                    <FontAwesomeIcon icon={faCog} className="align-middle" />
                  </DropdownToggle>
                  <DropdownMenu right>
                    <Link
                      to={{
                        pathname: `/${myConstClass.TENANT_PAGE_PATH}${
                          login_type === "hr_admin" ||
                          login_type === "super_admin"
                            ? "myprofile/Add"
                            : "employees/profile"
                        }`,
                        state: {
                          _id: login_type === "hr_admin" ? admin_id : login_id,
                        },
                      }}
                    >
                      <DropdownItem>
                        <FontAwesomeIcon
                          icon={faArrowAltCircleRight}
                          className="mr-2 align-middle"
                        />
                        My Profile
                      </DropdownItem>
                    </Link>
                    <Link to="/">
                      <DropdownItem onClick={logout}>
                        <FontAwesomeIcon
                          icon={faArrowAltCircleRight}
                          className="mr-2 align-middle"
                        />
                        Sign out
                      </DropdownItem>
                    </Link>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </Nav>
            </Collapse>
          </>
        ) : (
          <>
            <Collapse navbar>
              <Nav
                className={!sidebar.isOnRight ? "ml-auto" : "mr-auto"}
                navbar
              >
                {back_common_url}
                {/* Similar minimized mobile dropdowns... */}
              </Nav>
            </Collapse>
            <NavbarSearch />
            <NavbarToggle />
          </>
        )}
      </Navbar>
    );
  }
}

export default connect((store) => ({
  sidebar: store.sidebar,
}))(Navbarnew);
